export const codes = {
    ERR_SIGNATURE_NOT_VALID: 'ERR_SIGNATURE_NOT_VALID'
};
//# sourceMappingURL=errors.js.map